<div class="card-base">
    <div class="card-content-study-report-search">
        <div class="chip-container">
            <mat-chip-list>
                <mat-chip color="accent" matTooltip="{{ filt.toolTip }}" selected *ngFor="let filt of searchFilters">
                    {{ filt.valueView }}
                    <mat-icon *ngIf="!filt.isRequired" (click)="filt.remove()">cancel</mat-icon>
                </mat-chip>
            </mat-chip-list>
        </div>

        <div class="card-container mat-elevation-z1">
            <div class="clearfix">
                <div class="pull-left div-header-left">
                    <app-search-filter-component #searchFilter (startSearch)="onStartSearch()" (endSearch)="onEndSearch($any($event))" [filter]="filters"></app-search-filter-component>
                    <app-study-report-historial-filter #filters></app-study-report-historial-filter>
                </div>

                <div class="pull-right div-header-right">
                    <button class="card-inline margin-top-medium margin-right-medium" [matMenuTriggerFor]="columnsMenu" type="button" mat-mini-fab matTooltip="Columnas visibles">
            <mat-icon>view_column</mat-icon>
          </button>

                    <mat-menu #columnsMenu="matMenu" class="columns-menu">
                        <button mat-menu-item (click)="showAllColumns(); $event.stopPropagation()">
              <mat-icon>visibility</mat-icon><span>Mostrar todas</span>
            </button>
                        <mat-divider></mat-divider>
                        <button *ngFor="let col of availableColumns" class="columns-menu-item" mat-menu-item (click)="setColumnVisibility(col.field, !col.visible); $event.stopPropagation()">
              <mat-checkbox
                [checked]="col.visible"
                (click)="$event.stopPropagation()"
                (change)="setColumnVisibility(col.field, $any($event).checked)"
                >{{ col.title }}</mat-checkbox
              >
            </button>
                    </mat-menu>

                    <mat-spinner *ngIf="loading || loadingAction" class="margin-right-small" diameter="36"></mat-spinner>
                </div>
            </div>

            <mat-divider></mat-divider>

            <div class="card-content margin-botton-medium">
                <div class="grid-scroll-container">
                    <p-table class="search-table" [value]="dataSource" [tableStyle]="{ width: '100%' }">
                        <ng-template pTemplate="header">
                            <tr class="search-table-header">
                                <th class="resizable-header" *ngFor="let col of orderedColumnsDefinition" [style.width.px]="col.width" (dragover)="onHeaderDragOver($event)" (drop)="onHeaderDrop($event, col.field)">
                                    <div class="header-top-row">
                                        <span class="header-drag-content">
                      <span class="column-title" (click)="sortByColumn(col.field)">
                        {{ col.title }}
                        <mat-icon class="sort-icon">{{ getSortIcon(col.field) }}</mat-icon>
                      </span>
                                        <mat-icon class="header-drag-handle" draggable="true" (dragstart)="onHeaderDragStart($event, col.field)" (dragend)="onHeaderDragEnd()" (click)="$event.stopPropagation()">drag_indicator</mat-icon>
                                        </span>
                                        <span class="column-resize-handle" (mousedown)="startResize($event, col.field)"></span>
                                    </div>
                                    <input class="column-filter-input" [value]="columnFilters[col.field] || ''" (click)="$event.stopPropagation()" (input)="onColumnFilterInput(col.field, $any($event.target).value)" placeholder="Filtrar" />
                                </th>
                                <th class="actions-column"></th>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-element>
                            <tr class="search-table-cell" (click)="viewHistorial(element)">
                                <td *ngFor="let col of orderedColumnsDefinition">
                                    {{ getCellValue(element, col.field) }}
                                </td>
                                <td class="actions-column" (click)="$event.stopPropagation()">
                                    <button mat-icon-button [matMenuTriggerFor]="menuItem" matTooltip="Acciones">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                                    <mat-menu #menuItem="matMenu">
                                        <button mat-menu-item (click)="viewHistorial(element)">
                      <mat-icon>visibility</mat-icon><span>Ver</span>
                    </button>
                                    </mat-menu>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>

                <pager [selectedAmount]="0" (selectedPageIndexChange)="selectedPageIndexChange($any($event))" #pager></pager>
            </div>
        </div>
    </div>
</div>